import React from 'react';
import Header from './Header';
import Footer from './Footer';
import GoogleReviewsBanner from '../GoogleReviewsBanner';
import { useLanguage } from '../../context/LanguageContext';

const Layout = ({ children }) => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  return (
    <div className="min-h-screen flex flex-col bg-slate-100">
      {/* Header stays LTR always */}
      <Header />
      {/* Only main content is RTL for Arabic */}
      <main className={`flex-grow pt-20 ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
        {children}
      </main>
      {/* Google Reviews Banner */}
      <GoogleReviewsBanner />
      {/* Footer content is RTL for Arabic */}
      <div className={isRTL ? 'rtl' : 'ltr'} dir={isRTL ? 'rtl' : 'ltr'}>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
